import { Key } from 'components/Paypal/enums/key.enum';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { parseAxiosError } from 'utils/errors';
import { settingApiService } from 'api/settings.api.service';

const parseSessionRememberMeDays = (value?: string): number => {
  if (!value) {
    return 90;
  }

  try {
    const parsed = JSON.parse(value) as { expdays?: number } | number;
    const days =
      typeof parsed === 'number' ? Number(parsed) : Number(parsed?.expdays);

    return Number.isFinite(days) && days > 0 ? days : 90;
  } catch {
    const days = Number(value);
    return Number.isFinite(days) && days > 0 ? days : 90;
  }
};

export const getSessionRememberMeDays = createAsyncThunk(
  'sessionRememberMeDays/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await settingApiService.getSetting(
        Key.SessionRememberMe,
      );
      if (data.length > 0) {
        return parseSessionRememberMeDays(data[0].value);
      }
      return 90;
    } catch (err: unknown) {
      const parsedError = parseAxiosError(err as never);

      if (parsedError.status === 403) {
        return 90;
      }

      return rejectWithValue(parsedError);
    }
  },
);

export const getPaypalEnableSetting = createAsyncThunk(
  'paypalEnableSetting/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await settingApiService.getSetting(
        Key.EnablePaymentMethodPayPal,
      );
      if (data.length > 0) {
        return Boolean(Number(data[0].value));
      }
      return false;
    } catch (err: unknown) {
      return rejectWithValue(parseAxiosError(err as never));
    }
  },
);

export const getNxtGenCartStoreNumberSetting = createAsyncThunk(
  'NxtGenCartStoreNumberSetting/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await settingApiService.getSetting(
        'NxtGenCartStoreNumberSetting',
      );
      if (data.length > 0) {
        return data[0].value;
      }
      return '';
    } catch (err: unknown) {
      return rejectWithValue(parseAxiosError(err as never));
    }
  },
);

export const getPaypalVersionSetting = createAsyncThunk(
  'paypalVersionSetting/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await settingApiService.getSetting(Key.UsePaypalVersion);

      if (data.length > 0) {
        return String(data[0].value);
      }
      return '';
    } catch (err: unknown) {
      return rejectWithValue(parseAxiosError(err as never));
    }
  },
);

export const getEnablePrintibleStrikeSetting = createAsyncThunk(
  'enablePrintibleStrike/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await settingApiService.getSetting(
        Key.EnablePrintibleStrikeThrough,
      );
      if (data.length > 0) {
        return Boolean(Number(data[0].value));
      }
      return false;
    } catch (err: unknown) {
      return rejectWithValue(parseAxiosError(err as never));
    }
  },
);

export const getTaxSetting = createAsyncThunk(
  'taxSetting/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await settingApiService.getSetting(Key.TaxSetting);
      if (data.length > 0) {
        return String(data[0].value);
      }
      return false;
    } catch (err: unknown) {
      return rejectWithValue(parseAxiosError(err as never));
    }
  },
);
